import { type Team } from '@/entities/team';
import request from '@/shared/api/request';

export const getTeam = (uuid: string): Promise<{ team: Team }> =>
  request({
    url: `/teams/${uuid}`,
  });
